import { VideoBoxComponent } from "front-end/components/video-box/video-box.component";
import { deviceService } from "core/features/device/device.service";
import { DeviceType } from "core/features/device/enums/device-type.enum";

export class VideoBoxService {
    private _currentContext: JQuery = $();

    private _videoBox: VideoBoxComponent = null;

    private handleDeviceUpdate(isMobile: boolean): void {
        if(this._videoBox) {
            if(isMobile) {
                this._videoBox.hide();
            } else {
                this._videoBox.show();
            }
        } else if(!isMobile) {
            this.parseContext();
        }
    }

    private bindEvents(): void {
        deviceService.deviceType
            .subscribe((deviceType: DeviceType) => this.handleDeviceUpdate(deviceType === DeviceType.Mobile));
    }

    private parseContext(): void {
        const videoBox = $(VideoBoxComponent.SELECTOR, this._currentContext);
        this._videoBox = new VideoBoxComponent();
        this._videoBox.on("ready")
            .subscribe(() => this._videoBox.playVideo());
        this._videoBox.init(videoBox);
    }

    public destroy(): void {
        if (this._videoBox) {
            this._videoBox.destroy();
        }
    }

    public init = (context: JQuery): void => {
        this._currentContext = context || this._currentContext;

        this.bindEvents();
    };

    public static init(context: JQuery): VideoBoxService {
        const service = new VideoBoxService();
        service.init(context);

        return service;
    }
}
